module.exports = __webpack_public_path__ + "static/media/fantasyAmbient.04891dcd.mp3";